import { create } from "zustand";
import { EInstallationTier } from "../model/Installation.model";

export const UPGRADE_TIER = EInstallationTier;

export type UpgradeTier = EInstallationTier;

interface IShowUpgrade {
    planTypeUpgradePopup: UpgradeTier | undefined;
    upgradePopupTitle?: string | undefined;
    upgradePopupSubtitle?: string | undefined;
    upgradePopupBulletPoints?: string[] | undefined;
    upgradePopupVariant?: "default" | "addon";
}

interface NotificationState extends IShowUpgrade {
    isVisibleUpgradePopup: boolean;
    isVisibleScheduleMeeting: boolean;
    showUpgradePopup: (data: IShowUpgrade) => Promise<any>;
    hideUpgradePopup: () => void;
    resetUpgradePopup: () => void;
    showScheduleMeeting: () => Promise<void>;
}

const initialUpgradePopupState: IShowUpgrade = {
    planTypeUpgradePopup: undefined,
    upgradePopupTitle: undefined,
    upgradePopupSubtitle: undefined,
    upgradePopupBulletPoints: undefined,
    upgradePopupVariant: "default",
};

const useNotificationStore = create<NotificationState>((set) => ({
    isVisibleUpgradePopup: false,
    isVisibleScheduleMeeting: false,
    ...initialUpgradePopupState,
    hideUpgradePopup: () => {
        set((state) => ({
            ...state,
            isVisibleUpgradePopup: false,
            isVisibleScheduleMeeting: false
        }))
    },
    resetUpgradePopup: () => {
        set((state) => ({
            ...state,
            ...initialUpgradePopupState,
            isVisibleScheduleMeeting: false,
        }))
    },
    showUpgradePopup: async (data: IShowUpgrade) => {
        set((state) => ({
            ...state,
            ...initialUpgradePopupState,
            ...data,
            isVisibleUpgradePopup: true,
            isVisibleScheduleMeeting: false,
        }))
    },
    showScheduleMeeting: async () => {
        set((state) => ({
            ...state,
            isVisibleScheduleMeeting: true
        }))
    }
}));

export { useNotificationStore };
